<template>
  <q-card flat bordered>
    <q-card-section class="q-pa-sm bg-grey-2 text-brand7 q-pb-md">
      <div class="q-px-sm">
        <span class="semi-bordered-bottom text-bold">Billing Address</span>
      </div>
    </q-card-section>

    <q-separator />
    <q-card-section>
      <div class="row justify-around q-pb-sm cp-btns">
        <q-btn
          rounded
          dense
          class="q-px-sm"
          color="brand5"
          label="Same as shipper"
          @click="$emit('use-info', 'shipper')"
        />
        <q-btn
          rounded
          dense
          class="q-px-sm"
          color="brand5"
          label="Same as pickup"
          @click="$emit('use-info', 'origin')"
        />
        <q-btn
          rounded
          dense
          class="q-px-sm"
          color="brand5"
          label="Same as delivery"
          @click="$emit('use-info', 'destination')"
        />
      </div>

      <label>First Name *</label>
      <app-editable-input
        :data="value.firstName"
        name="firstName"
        @input="
          handleChangeInput($event);
          delayTouch(validation.firstName, $options.touchMap);
        "
        :error="validation.firstName.$error"
        outlined
        dense
        color="brand6"
      />
      <label>Last Name *</label>
      <app-editable-input
        :data="value.lastName"
        name="lastName"
        @input="
          handleChangeInput($event);
          delayTouch(validation.lastName, $options.touchMap);
        "
        :error="validation.lastName.$error"
        outlined
        dense
        color="brand6"
      />
      <label>Email *</label>
      <app-editable-input
        :data="value.email"
        name="email"
        @input="
          handleChangeInput($event);
          delayTouch(validation.email, $options.touchMap);
        "
        :error="validation.email.$error"
        outlined
        dense
        color="brand6"
      />
      <label>Address *</label>
      <app-editable-input
        :data="value.address"
        name="address"
        @input="
          handleChangeInput($event);
          delayTouch(validation.address, $options.touchMap);
        "
        :error="validation.address.$error"
        outlined
        dense
        color="brand6"
      />
      <label>City *</label>
      <app-select-input
        :readonly="false"
        :action="false"
        hide-dropdown-icon
        use-input
        :options="filterOptions"
        option-label="label"
        option-value="value"
        :value="value.city"
        @input="
          handleSelectChange($event);
          delayTouch(validation.city, $options.touchMap);
        "
        @filter="filterCityFn"
        :loading="searchingCity"
        :error="validation.city.$error"
        outlined
        dense
        color="brand6"
      />
      <label>State *</label>
      <app-editable-input
        :data="value.state"
        name="state"
        @input="
          handleChangeInput($event);
          delayTouch(validation.state, $options.touchMap);
        "
        :error="validation.state.$error"
        outlined
        dense
        color="brand6"
      />
      <label>Zipcode *</label>
      <app-select-input
        :readonly="false"
        :action="false"
        hide-dropdown-icon
        use-input
        :options="filterOptions"
        option-label="label"
        option-value="value"
        :value="value.zipcode"
        @input="
          handleSelectChange($event);
          delayTouch(validation.zipcode, $options.touchMap);
        "
        @filter="filterZipcodeFn"
        :loading="searchingZipcode"
        :error="validation.zipcode.$error"
        outlined
        dense
        color="brand6"
      />

      <label>Company(Optional)</label>
      <app-editable-input
        :data="value.companyName"
        name="companyName"
        @input="handleChangeInput($event)"
        outlined
        dense
        color="brand6"
      />
    </q-card-section>
  </q-card>
</template>
<script>
import AppEditableInput from '@client/components/form/editable-input';
import { RouteRunner } from '@client/third-party';
import AppSelectInput from '@client/components/form/select-input';

export default {
  name: 'AppBillingAddress',
  props: {
    value: Object,
    validation: Object
  },
  components: {
    AppEditableInput,
    AppSelectInput
  },
  data() {
    return {
      searchingCity: false,
      searchingZipcode: false,
      filterOptions: []
    };
  },
  methods: {
    handleChangeInput(value) {
      const { name, model } = value;
      this.$emit('input', {
        ...this.value,
        [name]: model
      });
    },
    async filterFn(val) {
      if (!val) return [];

      const response = await RouteRunner.getLocations(val);
      if (response) {
        return response.map((el) => ({
          label: `${el.city}, ${el.id} ${el.zip}`,
          value: el
        }));
      }

      return [];
    },
    async filterCityFn(val, update) {
      this.searchingCity = true;
      const options = await this.filterFn(val);
      update(() => {
        this.filterOptions = options;
      });
      this.searchingCity = false;
    },
    async filterZipcodeFn(val, update) {
      this.searchingZipcode = true;
      const options = await this.filterFn(val);
      update(() => {
        this.filterOptions = options;
      });
      this.searchingZipcode = false;
    },
    handleSelectChange(props) {
      const { value } = props;
      this.state = value.id;
      this.zipcode = value.zip;
      this.city = value.city;

      this.$emit('input', {
        ...this.value,
        state: value.id.trim(),
        zipcode: value.zip.trim(),
        city: value.city.trim()
      });
    }
  }
};
</script>
<style lang="scss">
  .cp-btns{
    row-gap:10px;
  }
</style>
